import { createWidgetMixin } from 'vue-instantsearch';
import { store } from '../store';

const noopConnector = () => () => ({ render() {}, dispose() {} });

export default {
  mixins: [createWidgetMixin({ connector: noopConnector })],
  props: {
    type: {
      type: String,
      validator: val => ['restaurant', 'cinema'].includes(val),
      required: true,
    },
  },
  data() {
    return {
      state: store.state,
    };
  },
  computed: {
    widgetParams() {
      return {
        attribute: 'type',
        value: this.type,
        identifier: this.identifier,
      };
    },
  },
  mounted() {
    // keep track of type globally, so only one value is kept
    // widgets mount in correct order
    store.setType(this.type);
    // helper is null on initial search, but that's fine, since the search will happen anyway
    this.instantSearchInstance.helper &&
      this.instantSearchInstance.helper.search();
  },
  render() {
    return null;
  },
};
